import React from "react";
import { useOutletContext } from "react-router-dom";
import { PageHead, RailCard, KeyValue, Note } from "@/components/portal/crm/kit";
import { ChatPanel } from "@/components/portal/crm/ChatPanel";
import { NotifyPrefs } from "@/components/portal/NotifyPrefs";

/** Shared by both portals — the desk thread as a page of its own. */
export default function Messages() {
  const ctx = useOutletContext() || {};
  const isLender = !!ctx?.me?.company_name;

  return (
    <>
      <PageHead
        eyebrow="Your Connexis desk"
        title="Messages"
        lede="One thread with the desk. Everything here also lands in their inbox, and a reply by email arrives back on this page."
        testId="portal-messages-head"
      />

      <div className="grid items-start gap-7 xl:grid-cols-[minmax(0,1fr)_320px]">
        <div className="min-w-0"><ChatPanel /></div>
        <div className="space-y-4">
          <RailCard title="Who you are talking to" testId="portal-messages-who">
            <KeyValue label="Desk hours" value="5am–11.30pm UK" />
            <KeyValue label="Days" value="Seven" />
            <KeyValue label="Reply by email" value="Works too" />
            <p className="mt-3 border-t border-[#EFF3F8] pt-3 text-[12.5px] leading-relaxed text-slate-500">
              {isLender
                ? "Ask about appetite, a case you are holding, or anything we routed that didn't fit — it changes what we send you next."
                : "Ask about a case, a payment, or what a desk actually meant by a decline."}
            </p>
          </RailCard>
          <NotifyPrefs />
          <Note>Attach a document and we file it on the case, not just in the chat.</Note>
        </div>
      </div>
    </>
  );
}
